import { useEffect, type CSSProperties } from 'react';
import { Icon } from './Icon';
import { DESIGN_TEMPLATES, type TemplatePreview } from '../data/designTemplates';
import '../styles/stylepicker.css';

// Galleria di scelta del TEMPLATE (scheletro). Operatore-scelto, come lo Stile.
// Le card sono mini-anteprime DETTAGLIATE col locale-esempio: Lampo = "MORSO"
// (hamburgeria), Classico = "Trattoria Carlotta" — così si vede esattamente
// com'è ogni template, non con le specifiche del cliente attuale.

// Font display per le mini-anteprime: caricati on-demand (strumento interno).
const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Anton&family=Archivo:wght@700;800&family=Cormorant+Garamond:ital,wght@0,500;0,600;1,600&display=swap';

const lines3: CSSProperties = { display: 'flex', flexDirection: 'column', gap: 2, width: 13, flex: 'none' };

/** Mini-homepage del template "Lampo" (esempio: MORSO, hamburgeria). */
function LampoThumb() {
  return (
    <>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 10px', background: '#E2402A' }}>
        <span style={{ fontFamily: "'Anton', sans-serif", fontSize: 14, color: '#fff', letterSpacing: '.02em' }}>
          MORSO<svg viewBox="0 0 24 24" style={{ width: 11, height: 11, fill: '#F2C200', marginLeft: 2 }}><path d="M7 2v11h3v9l7-12h-4l4-8z" /></svg>
        </span>
        <span style={lines3}>{[0, 1, 2].map((i) => <span key={i} style={{ height: 1.5, background: '#fff', borderRadius: 1 }} />)}</span>
      </span>
      <span style={{ display: 'block', background: '#141210', borderTop: '1.5px solid #F2C200', borderBottom: '1.5px solid #F2C200', padding: '2px 0', fontFamily: "'Anton', sans-serif", fontSize: 6, letterSpacing: '.12em', color: '#F2C200', whiteSpace: 'nowrap', overflow: 'hidden', textAlign: 'center' }}>
        HAMBURGER · FRITTI · BIRRA · APERTO FINO ALL'1 ·
      </span>
      <span style={{ position: 'relative', display: 'grid', gridTemplateColumns: '1.05fr .95fr', flex: 1 }}>
        <span style={{ display: 'flex', alignItems: 'center', paddingLeft: 11 }}>
          <span style={{ fontFamily: "'Anton', sans-serif", fontSize: 38, lineHeight: 0.84, color: '#fff', transform: 'skewX(-6deg)', letterSpacing: '-1.5px' }}>MORSO</span>
        </span>
        <span style={{ background: 'linear-gradient(135deg,#7a3a22,#2a1810)' }} />
        <span style={{ position: 'absolute', left: '48%', top: '50%', transform: 'translate(-50%,-50%)', width: 34, height: 34, borderRadius: '50%', background: '#F2C200', display: 'grid', placeItems: 'center', fontSize: 14, color: '#141210', boxShadow: '0 3px 8px rgba(0,0,0,.45)' }}><svg viewBox="0 0 24 24" style={{ width: 15, height: 15, fill: '#141210' }}><path d="M7 2v11h3v9l7-12h-4l4-8z" /></svg></span>
      </span>
    </>
  );
}

/** Mini-homepage del template "Classico" (esempio: Trattoria Carlotta). */
function ClassicoThumb() {
  return (
    <>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 11px', borderBottom: '1px solid rgba(38,36,29,.1)' }}>
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 13, fontWeight: 600, color: '#26241D' }}>Trattoria Carlotta</span>
        <span style={lines3}>{[0, 1, 2].map((i) => <span key={i} style={{ height: 1.5, background: '#7C7561', borderRadius: 1 }} />)}</span>
      </span>
      <span style={{ display: 'grid', gridTemplateColumns: '1fr .82fr', flex: 1 }}>
        <span style={{ padding: '0 11px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span style={{ fontSize: 6, letterSpacing: '.22em', color: '#B0833C', textTransform: 'uppercase', marginBottom: 5 }}>Trattoria · Trastevere</span>
          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, lineHeight: 0.92, color: '#26241D' }}>
            Trattoria<br /><span style={{ fontStyle: 'italic', color: '#B0833C' }}>Carlotta</span>
          </span>
          <span style={{ marginTop: 9, alignSelf: 'flex-start', fontSize: 6, background: '#2F3D2E', color: '#F7F2E7', padding: '4px 8px', borderRadius: 2, letterSpacing: '.08em' }}>PRENOTA UN TAVOLO</span>
        </span>
        <span style={{ background: 'linear-gradient(135deg,#cdb791,#8d7c5c)' }} />
      </span>
    </>
  );
}

/** Mini-homepage del template "Carta" (esempio: TÒRO, braceria) — carta + rosso + grottesco. */
function CartaThumb() {
  return (
    <>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 11px' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <span style={{ width: 18, height: 18, borderRadius: '50%', background: '#bd2f23', color: '#ece7da', display: 'grid', placeItems: 'center', fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 10 }}>T</span>
          <span style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 13, color: '#16140f', letterSpacing: '.02em' }}>TÒRO</span>
        </span>
        <span style={lines3}>{[0, 1, 2].map((i) => <span key={i} style={{ height: 1.5, background: '#16140f', borderRadius: 1 }} />)}</span>
      </span>
      <span style={{ display: 'grid', gridTemplateColumns: '.78fr 1.22fr', gap: 9, flex: 1, padding: '0 11px 0' }}>
        <span style={{ background: 'linear-gradient(135deg,#3a2a1c,#16120c)' }} />
        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 25, lineHeight: 0.88, color: '#16140f', textTransform: 'uppercase', letterSpacing: '-.02em' }}>TÒRO</span>
          <span style={{ fontFamily: "'Archivo', sans-serif", fontSize: 6, fontWeight: 700, letterSpacing: '.14em', color: '#16140f', textTransform: 'uppercase', marginTop: 6 }}>La braceria di Bologna</span>
          <span style={{ marginTop: 9, width: 42, height: 42, border: '1.2px solid #16140f', borderRadius: '50%', display: 'grid', placeItems: 'center', fontSize: 5.5, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: '#16140f' }}>Prenota</span>
        </span>
      </span>
      <span style={{ position: 'relative', height: 30, background: '#1a1813', overflow: 'hidden', marginTop: 8 }}>
        <span style={{ position: 'absolute', right: -14, top: -16, width: 52, height: 52, borderRadius: '50%', background: '#bd2f23' }} />
        <span style={{ position: 'absolute', left: 11, top: 9, fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 10, color: '#ece7da', textTransform: 'uppercase', letterSpacing: '.02em' }}>La carne</span>
      </span>
    </>
  );
}

/** Mini-homepage del template "Marea" — hero immersivo scuro, marchio centrato, slideshow. */
function MareaThumb() {
  return (
    <>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 11px' }}>
        <span style={{ fontFamily: 'Georgia, serif', fontWeight: 600, fontSize: 11, color: '#f4efe4', letterSpacing: '.1em' }}>Marea</span>
        <span style={{ display: 'inline-flex', gap: 5 }}>{[0, 1, 2].map((i) => <span key={i} style={{ width: 10, height: 1.2, background: 'rgba(244,239,228,.55)', borderRadius: 1 }} />)}</span>
        <span style={{ border: '1px solid rgba(244,239,228,.5)', padding: '3px 7px', fontSize: 5.5, fontWeight: 700, letterSpacing: '.16em', color: '#f4efe4', textTransform: 'uppercase' }}>Prenota</span>
      </span>
      <span style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', gap: 4, background: 'repeating-linear-gradient(92deg,#0d2233 0 7%,#143a58 7% 7.6%,#0b1d2c 7.6% 14%)' }}>
        <span style={{ fontFamily: 'Georgia, serif', fontWeight: 500, fontSize: 27, lineHeight: 0.9, color: '#f4efe4' }}>Marea</span>
        <span style={{ fontFamily: "'Helvetica Neue', sans-serif", fontWeight: 600, fontSize: 5.5, letterSpacing: '.3em', color: '#f4efe4', textTransform: 'uppercase', marginTop: 3 }}>Cucina di mare</span>
        <span style={{ width: 22, height: 1.4, background: '#c9a24b', margin: '3px 0' }} />
        <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 7, color: 'rgba(244,239,228,.7)' }}>prima fila sul mare</span>
      </span>
      <span style={{ display: 'flex', gap: 5, justifyContent: 'center', padding: '0 0 9px' }}>
        {[0, 1, 2, 3].map((i) => <span key={i} style={{ width: 5, height: 5, borderRadius: '50%', border: '1px solid rgba(244,239,228,.6)', background: i === 2 ? '#c9a24b' : 'transparent' }} />)}
      </span>
    </>
  );
}

function Thumb({ p, sel }: { p: TemplatePreview; sel: boolean }) {
  return (
    <span
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: 176,
        borderRadius: 8,
        overflow: 'hidden',
        border: '1px solid var(--rule)',
        background: p.bg,
        outline: sel ? '2.5px solid var(--terra)' : 'none',
        outlineOffset: 1,
      }}
    >
      {sel && <span className="sp-badge" style={{ zIndex: 2 }}>Attuale</span>}
      {p.vibe === 'lampo' ? <LampoThumb /> : p.vibe === 'carta' ? <CartaThumb /> : p.vibe === 'marea' ? <MareaThumb /> : <ClassicoThumb />}
    </span>
  );
}

interface Props {
  current: string;
  onSelect: (id: string) => void;
  onClose: () => void;
}

export function TemplatePicker({ current, onSelect, onClose }: Props) {
  useEffect(() => {
    if (!document.getElementById('tp-fonts')) {
      const l = document.createElement('link');
      l.id = 'tp-fonts';
      l.rel = 'stylesheet';
      l.href = FONTS_HREF;
      document.head.appendChild(l);
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="mscrim open" onMouseDown={onClose}>
      <div className="modal sp-modal" role="dialog" aria-modal="true" aria-label="Scegli il template del sito" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3>Scegli il template del sito</h3>
          <button type="button" className="dr-close" onClick={onClose} aria-label="Chiudi">
            <Icon name="x" size={18} />
          </button>
        </div>
        <div className="modal-body sp-body">
          <div className="rs-note" style={{ marginBottom: 14 }}>
            Il <b>template</b> è lo <b>scheletro</b> del sito (com'è fatto e come si scorre). Le anteprime usano un locale d'esempio. Lo <b>Stile</b> (colori e font) si sceglie dopo, qui sotto. Il template lo scegli tu, non il cliente.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {DESIGN_TEMPLATES.map((t) => {
              const sel = t.id === current;
              return (
                <button key={t.id} type="button" className="sp-card" aria-pressed={sel} onClick={() => onSelect(t.id)}>
                  <Thumb p={t.preview} sel={sel} />
                  <span className="sp-label">{t.label}</span>
                  <span className="sp-sub">{t.suited}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
